import { makeStateKey } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable } from 'rxjs';
import { CacheRef, resolverSSGFirst } from './ssg-first.utils';
import type { PaginaEntry } from '@core/interfaces/modyo';

const STATE_KEY = makeStateKey<PaginaEntry>('pagina-datos-economicos-seccion-1');
const cache: CacheRef<PaginaEntry> = { valor: null };

export const resetCacheClienteDatosEconomicosSeccion1 = (): void => {
  cache.valor = null;
};

export const datosEconomicosSeccion1Resolver: ResolveFn<PaginaEntry | null> = (): Observable<PaginaEntry | null> =>
  resolverSSGFirst({
    stateKey: STATE_KEY,
    cache,
    rutaSsg: 'datos-economicos-seccion-1',
    uidTipo: 'pagina',
    slug: 'paginadatoseconomicosseccion1',
  });
